import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=5beea03c&scoped=true"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=5beea03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beea03c",
  null
  
)

export default component.exports